import { render, staticRenderFns } from "./ReceiveRelated_Action.vue?vue&type=template&id=42507556&"
import script from "./ReceiveRelated_Action.vue?vue&type=script&lang=js&"
export * from "./ReceiveRelated_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports